import { IStore } from "modules/types";

export const getGlobalError = ({errors: {text}}: IStore) => text;